export const messages = {
  en: {
    productDetail: {
      title: 'Product Detail',
      marketPrice: 'Market Price',
      price: 'Price',
      delivery: 'Delivery',
      platformDelivery: 'Platform Delivery',
      specs: 'Specifications',
      inStock: 'In Stock',
      outOfStock: 'Out Of Stock',
      quantity: 'Quantity',
      buyNow: 'Buy Now',
      addToCart: 'Add To Cart',
      consult: 'Consult',
      productDetailTab: 'Product Detail',
      customerReviewTab: 'Customer Reviews',
      noReviews: 'No reviews yet~',
      helpText: 'Consultation phone: {phone}, or go to "{platform}" mini program'
    }
  },
  zh: {
    productDetail: {
      title: '商品详情',
      marketPrice: '市场价',
      price: '价格',
      delivery: '配送',
      platformDelivery: '平台发货',
      specs: '规格',
      inStock: '有货',
      outOfStock: '无货',
      quantity: '数量',
      buyNow: '立即购买',
      addToCart: '加入购物车',
      consult: '咨询',
      productDetailTab: '商品详情',
      customerReviewTab: '客户评价',
      noReviews: '暂无评价~',
      helpText: '咨询电话：{phone}，或移步"{platform}"小程序'
    }
  }
}